export default function validationEdition(response, messages) {
  response.error.validationErrors.forEach((error) => {
    const message = error.message;
    if (message.indexOf('GOOGLE_MAP_KEY_INVALID') !== -1) {
      messages.push({
        message: 'general.messages.error.messageErrorCleApiEdition',
      });
    }
    if (message.indexOf('EDITION_NOEDITION') !== -1) {
      messages.push({
        message: 'general.messages.error.noEdition',
      });
    }
  });
}
